import { docsReturnUrl } from "#shared/lib/docs-href.ts";

const AUTH_ERROR_KEY = "auth_error";
const AUTH_RETURN_URL_KEY = "auth_return_url";

// Logout redirects with no message. A token refresh still in flight can fail
// afterward and must not replace that clean redirect with a fetch error.
let suppressAuthError = false;

export function redirectToLogin(errorMessage?: string): void {
  if (!errorMessage) {
    suppressAuthError = true;
    sessionStorage.removeItem(AUTH_ERROR_KEY);
  } else if (!suppressAuthError) {
    sessionStorage.setItem(AUTH_ERROR_KEY, errorMessage);
  }
  const returnUrl = `${window.location.pathname}${window.location.search}`;
  if (returnUrl !== "/login") {
    sessionStorage.setItem(AUTH_RETURN_URL_KEY, returnUrl);
  }
  window.location.href = "/login";
}

// Resolved with URL rather than prefix checks: browsers drop tabs and
// newlines, so `/\t/evil.example` would otherwise become `//evil.example`.
function sameOriginReturnPath(value: string): string | null {
  if (!value.startsWith("/")) return null;
  let url: URL;
  try {
    url = new URL(value, window.location.origin);
  } catch {
    return null;
  }
  if (url.origin !== window.location.origin) return null;
  if (url.pathname === "/login" || url.pathname.startsWith("/login/")) {
    return null;
  }
  return `${url.pathname}${url.search}${url.hash}`;
}

export function authReturnUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  return sameOriginReturnPath(value) ?? docsReturnUrl(value);
}

export function rememberAuthReturn(value: string | undefined): void {
  const url = authReturnUrl(value);
  if (!url) return;
  sessionStorage.setItem(AUTH_RETURN_URL_KEY, url);
}

export function consumeAuthReturnUrl(): string | null {
  const returnUrl = sessionStorage.getItem(AUTH_RETURN_URL_KEY);
  if (returnUrl) {
    sessionStorage.removeItem(AUTH_RETURN_URL_KEY);
  }
  return returnUrl;
}

export function consumeAuthError(): string | null {
  const msg = sessionStorage.getItem(AUTH_ERROR_KEY);
  if (msg) sessionStorage.removeItem(AUTH_ERROR_KEY);
  return msg;
}

export function redirectToApp(redirectTo?: string): void {
  window.location.href = redirectTo ?? "/";
}
